<template>
  <el-dialog
    title="查看下发消息"
    :modal-append-to-body="false"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancelForm"
    :visible.sync="actionDataBox"
    width="60%"
  >
    <div class="dialog_box">
      <div class="search_box">
        <el-select
          v-model="reqData.state"
          clearable
          placeholder="请选择"
          size="mini"
          @change="selectState"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <el-table :data="resData.list" height="500px" class="dialog_table_box">
        <el-table-column label="序号" width="70" align="center">
          <template slot-scope="scope">
            {{ reqData.pageSize * (reqData.pageNum - 1) + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="name" label="学校" align="center" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="address" label="地址" align="center" show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="fileType"
          label="状态"
          align="center"
          show-overflow-tooltip
        >
          <template v-slot="scope">
            {{ scope.row.state == 1 ? "已查看" : "未查看" }}
          </template>
        </el-table-column>
      </el-table>
      <div class="dialog_pagination_box" v-if="resData.total > 0">
        <el-pagination
          @current-change="handleCurrentChange"
          background
          :current-page="resData.pageNum"
          :page-size="resData.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="resData.total"
        >
        </el-pagination>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "noticesList",
  components: {},
  props: {
    noticesResize: {
      type: Number,
      default: {
        return: 0,
      },
    },
    selObj: {
      type: Object,
      default: {
        return: {},
      },
    },
  },
  data() {
    return {
      actionDataBox: false,
      options: [
        {
          value: 1,
          label: "已查看",
        },
        {
          value: 2,
          label: "未查看",
        },
      ],
      reqData: {
        state: "",
        notificationId: "",
        type: "",
        pageNum: 1,
        pageSize: 20,
      },
      resData: {
        pageSize: 0,
        pageNum: 0,
        total: 0,
        pages: 0,
        list: [],
      },
    };
  },
  watch: {
    noticesResize: function (newVal) {
      if (newVal) {
        // console.log(this.selObj, 222);
        this.reqData.notificationId = this.selObj.notificationId;
        this.reqData.type = this.selObj.identification;
        this.getList();
        this.actionDataBox = true;
      }
    },
  },
  computed: {},
  methods: {
    handleCurrentChange(val) {
      this.reqData.pageNum = val;
      console.log(`当前页: ${val}`);
      this.getDataList();
    },
    cancelForm() {
      this.actionDataBox = false;
      this.clearData();
    },
    clearData() {
      this.reqData.state = "";
    },
    selectState(state) {
      // console.log("object", state);
      this.reqData.state = state;
      this.getList();
    },
    getList() {
      this.reqData.pageNum = 1;
      this.getDataList();
    },
    async getDataList() {
      let res = await this.$Http.getEduNoticesListSchool(this.reqData);
      if (res.code == 200) {
        this.resData.pageSize = res.data.pageSize;
        this.resData.pageNum = res.data.pageNum;
        this.resData.total = res.data.total;
        this.resData.pages = res.data.pages;
        this.resData.list = res.data.list;
      } else if (res.code == 101) {
        this.resData.total = 0;
        this.resData.list = [];
      } else {
        this.$message({
          message: res.messsage,
          type: "error",
        });
      }
    },
  },
  created() {},
  mounted() {},
};
</script>
<style scoped lang="scss">
@import "../../../../../../public/css/edu_pages.scss";
</style>
